export default "__VITE_ASSET__e818faf0__"